import { css } from '@emotion/react';

const styles = {
  containerStyles: css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30rem;
  `,
  iconContainerStyles: css`
    margin: 0 0.5rem;
  `
};

export default styles;
